 
 
export class RequestModelForForgetPwd {
    id: string;
    otp: string;
    authType :string;
    newPassword: string;
}
